<template>
  <v-card flat class="ma-0 round-0 p-0 bg-footer">
    <v-card-text class="pa-0 ma-0 wrapper-bg pb-10">
      <v-row no-gutters>
        <v-col cols="12 text-center copyright-text" no-gutters>
          <small class="success--text"> <b>V1.0.0 Busyug</b>  </small>
          Copyright  &copy; {{ this_year }}. Xyola (ug) ltd. - Kampala, Uganda.
          All rights reserved.   
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col cols="12 pl-5 pr-5 align-center mt-2" no-gutters>
          <v-form
            v-model="valid"
            ref="new_letter_subscription_form"
            v-on:submit.prevent="on_subscribe_newsletter"
          >
            <div class="d-flex justify-space-between pl-5 pr-5">
              <div class="footer-section-header text-left mr-2">
                Lets Keep In Touch
              </div>
              <v-text-field
                v-model="email"
                :rules="email_rules"
                label="Subscribe to our weekly newsletter"
                required
                prepend-inner-icon="mdi-email-variant"
                dense
                dark
                filled
                outlined
                clearable
                class="flex-md-grow-1"
                autocomplete="off"
                append-icon="mdi-send"
                :disabled="is_loading"
                @click:append="on_subscribe_newsletter"
              ></v-text-field>
            </div>
          </v-form>
          <v-divider></v-divider>
        </v-col>

        <v-col cols="3" no-gutters>
          <div class="footer-section-header">Quick Links</div>
          <div class="text-left pa-1">
            <v-btn
              v-for="(link, index) in quick_links"
              :key="index"
              class="ma-0 justify-start"
              block
              :to="link.href"
              dense
              text
              small
              color="success"
            >
              <v-icon>mdi-circle-small</v-icon>
              {{ link.label }}
            </v-btn>
          </div>
        </v-col>
        <v-col cols="4" no-gutters>
          <div class="footer-section-header">Top Categories</div>
          <div class="text-left pa-1">
            <v-btn
              v-for="top_category in top_categories"
              :key="top_category.id"
              class="ma-0 justify-start"
              block
              @click="view_catgeory(top_category.id)"
              
              dense
              text
              small
              color="success"
            >
              <v-icon class="mr-2">{{ top_category.icon }}</v-icon>
              {{ top_category.name }}
              <small>({{(top_category.belongings.length > 0)?top_category.belongings[0].count_business_id: 0}})</small>
            </v-btn>
          </div>
        </v-col>
        <v-col cols="5" no-gutters>
          <div class="footer-section-header">Contacts</div>
          <div class="text-left pa-1">
            <v-btn
              class="ma-0 justify-start text-left"
              block
              dense
              text
              small
              
              color="success"
            >
              <v-icon class="mr-2">mdi-home-map-marker</v-icon>
              {{page_info.plot_number}}<br/>
              {{page_info.city_country}}
            </v-btn>
            <v-btn
              class="ma-0 justify-start mt-1"
              block
              :href="'tel:' + page_info.phone_number"
              dense
              text
              link
              small
              color="success"
            >
              <v-icon class="mr-2">mdi-face-agent</v-icon>
              {{ page_info.phone_number }}
            </v-btn>
            <v-btn
              class="ma-0 justify-start mt-1"
              block
              :href="'mailto:' + page_info.email_address"
              dense
              text
              small
              color="success"
            >
              <v-icon class="mr-2">mdi-email-outline</v-icon>
              {{ page_info.email_address }}
            </v-btn>
          </div>
          <div class="footer-section-header">Follow Us</div>
          <v-btn
              v-for="(social_media_link,index) in social_media_links"
              :key="index"
              class="mr-1 mt-1"
              :href="social_media_link.value"
              target="_blank"
              dense
              icon
              large
              outlined
              color="success"
            >
            <v-icon>{{social_media_link.icon}}</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>

    <v-dialog v-model="show_success_dialog" max-width="400">
      <v-card>
        <v-card-title class="headline"
          >Busyug Newsletter</v-card-title
        >
        <v-divider></v-divider>
        <br />
        <v-card-text>
          <b>Thank you</b> for subscribing to our weekly newsletter.
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="show_errors_dialog" max-width="500">
      <v-card>
        <v-card-title class="headline red--text text--darken-1"
          >!!!Errors. Busyug Newsletter</v-card-title
        >
        <v-divider></v-divider>
        <br />
        <v-card-text v-for="(error, index) in errors" :key="index">
          {{ error }}
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import ServerClient from "./../lib/ServerClient";
import page_info from "./../lib/page_info";

export default {
  name: "CenterFooter",
  props: {
    is_loading: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    this_year: (new Date()).getFullYear(),
    email: "",
    email_rules: [
      (v) => {
        v = v ? v.trim() : v;
        return !!v || "E-mail Address is required";
      },
      (v) => /.+@.+/.test(v) || "E-mail Address must be a valid email format",
    ],
    valid: false,
    show_success_dialog: false,
    show_errors_dialog: false,
    errors: [],
    quick_links: [
      {
        href: "/about",
        label: "About Us",
      },
      {
        href: "/contact",
        label: "Contact Us",
      },
      {
        href: "/terms",
        label: "Terms & Conditions",
      },
      {
        href: "/policy",
        label: "Privacy & Data Policy",
      },
      {
        href: "/team",
        label: "Meet The Team",
      },
    ],
    top_categories: [],
    page_info: page_info,
    social_media_links: page_info.get_social_media_links()
  }),
  methods: {
    on_subscribe_newsletter() {
      this.$refs.new_letter_subscription_form.validate();
      this.show_success_dialog = false;
      this.show_errors_dialog = false;
      if (this.valid) {
        this.$emit("on-show-loader");
        ServerClient.Footer.subscribe_to_news_letter(
          {
            email_address: this.email.trim(),
          },
          (res) => {
            this.email = "";
            this.show_success_dialog = true; //show thanks alert
            this.$emit("on-hide-loader");
            this.$refs.new_letter_subscription_form.resetValidation();
          },
          (errors) => {
            this.errors = errors;
            this.show_errors_dialog = true;
            this.$emit("on-hide-loader");
          }
        );
      }
    },
    view_catgeory(id){
      this.$router.push('/categories/' + id);
      this.$router.go(0);
    }
  },
  mounted() {
    //load the top 7 categories
    ServerClient.Categories.get_top_categories(
      {
        number_of_categories: 7,
      },
      (res) => {
        this.top_categories = res;
      },
      (errors) => {
        console.log(
          "CenterFooter: Errors while loading top categories ",
          errors
        );
      }
    );
  },
};
</script>

<style scoped>
.bg-footer {
  background-color: #047082;
}
.wrapper-bg {
  background-color: rgba(0, 0, 0, 0.5);
}

.footer-section-header {
  font-size: 14px;
  color: white;
  padding-top: 10px;
}

.copyright-text {
  color: #ccc;
  padding-top: 5px;
  padding-bottom: 5px;
}
</style>